import React, { useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const TwitterCallback = ({ setTwitterDetails }) => {
  const navigate = useNavigate()
  const defaultBackendUrl =
    typeof window !== 'undefined' ? window.location.origin : ''
  const backendUrl = process.env.REACT_APP_BACKEND_URL || defaultBackendUrl

  useEffect(() => {
    axios
      .get(`${backendUrl}/twitter/me`, { withCredentials: true })
      .then((response) => {
        setTwitterDetails(response.data)
        navigate('/twitter/dashboard')
      })
      .catch((err) => {
        console.error('Error fetching Twitter user data:', err)
        // Optionally redirect to a login or error page.
      })
  }, [backendUrl, setTwitterDetails, navigate])

  return <div>Processing Twitter login...</div>
}

export default TwitterCallback
